<template>
    <div class="basic_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('FAQ')}}</div>
        </div>
        <div class="wrap">
            <van-collapse v-model="activeNames">
                <van-collapse-item
                        v-for="(item, index) in list"
                        :key="index"
                        :title="item.title"
                >
                    <div v-html="item.content"></div>
                </van-collapse-item>
            </van-collapse>
        </div>
    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "faq",
        data() {
            return {
                list:[],
                activeNames: []
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.getFaq();
        },
        methods: {
            getFaq() {
                Fetch('/index/faq', { }).then(res => {
                    this.list = res.data;
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .back_left {
        background: url(../../views/images/item/back_b.png) no-repeat center center;
    }
    .big_tit{
        color: #000000;
    }
    .wrap {
        padding: 10px;
    }
</style>